'use strict';

document.addEventListener('DOMContentLoaded', () => {
  const header = document.querySelector('.header');
  if (!header) return;

  const triggers = header.querySelectorAll('[data-header-menu-trigger]');
  if (!triggers.length) return;

  const panels = header.querySelectorAll('[data-header-menu-panel]');
  const brandsPanel = header.querySelector('.header__brands-dropdown');
  const brandsMediaQuery = window.matchMedia('(max-width: 991.98px)');

  const syncBrandsPanelPosition = () => {
    if (!brandsPanel) return;

    if (brandsMediaQuery.matches && brandsPanel.classList.contains('is-open')) {
      const top = Math.round(header.getBoundingClientRect().bottom);
      brandsPanel.style.setProperty('--header-brands-top', `${top}px`);
      document.documentElement.style.overflow = 'hidden';
    } else {
      brandsPanel.style.removeProperty('--header-brands-top');
      document.documentElement.style.overflow = '';
    }
  };

  const closeAll = () => {
    triggers.forEach((trigger) => {
      trigger.setAttribute('aria-expanded', 'false');
    });

    panels.forEach((panel) => {
      panel.classList.remove('is-open');
      panel.setAttribute('hidden', '');
    });

    header.classList.remove('is-menu-open');
    syncBrandsPanelPosition();
  };

  const openPanel = (trigger, panel) => {
    closeAll();
    trigger.setAttribute('aria-expanded', 'true');
    panel.classList.add('is-open');
    panel.removeAttribute('hidden');
    header.classList.add('is-menu-open');
    syncBrandsPanelPosition();
  };

  triggers.forEach((trigger) => {
    const panelId = trigger.getAttribute('aria-controls');
    const panel = panelId ? document.getElementById(panelId) : null;

    if (!panel) return;

    trigger.addEventListener('click', (event) => {
      event.preventDefault();
      event.stopPropagation();

      const isOpen = panel.classList.contains('is-open');

      if (isOpen) {
        closeAll();
      } else {
        openPanel(trigger, panel);
      }
    });
  });

  document.addEventListener('click', (event) => {
    if (!header.contains(event.target)) {
      closeAll();
    }
  });

  document.addEventListener('keydown', (event) => {
    if (event.key === 'Escape') {
      closeAll();
    }
  });

  window.addEventListener('resize', syncBrandsPanelPosition);
  brandsMediaQuery.addEventListener('change', syncBrandsPanelPosition);
});
